<template>
  <div class="hoa-col">
    <div class="hoa-carousel-container">
      <!-- Cập nhật class custom cho slick để xử lý padding/margin -->
      <VueSlickCarousel
        v-if="posts && posts.length > 0"
        v-bind="settings"
        ref="carousel"
        class="custom-slick-grid"
      >
        <div v-for="post in posts" :key="post._id" class="item-wrapper">
          <div class="hoa-card">
            <!-- ẢNH 3:2 -->
            <div class="hoa-image-container">
              <div class="hoa-image-wrapper">
                <img
                  :src="url + post.fileImage.fileId"
                  :alt="post.nameAuthor"
                  class="hoa-image"
                />
                <!-- Overlay Thông tin -->
                <div class="hoa-overlay">
                  <h3 class="hoa-name">{{ post.nameAuthor }}</h3>
                  <p
                    class="hoa-engname"
                    :title="formatDate(post.createdAtShow)"
                  >
                    <i class="fa fa-clock me-1"></i>
                    <span> {{ getFomartDateBefore(post.createdAtShow) }}</span>
                  </p>
                </div>
              </div>
            </div>

            <!-- Body nội dung -->
            <div class="hoa-card-body">
              <!-- SỬA: Bỏ truncate filter để CSS xử lý số dòng -->
              <p class="hoa-desc">{{ post.describe }}</p>
              <div class="hoa-card-footer">
                <ButtonCore
                  text="Chi tiết"
                  :handleClick="() => openPostModal(post)"
                  variantClass="btn-outline-info-core d-flex justify-content-center"
                  :customStyle="{
                    height: '30px',
                    fontSize: '0.9rem',
                    alignItems: 'center',
                    verticalAlign: 'center',
                  }"
                />
              </div>
            </div>
          </div>
        </div>
      </VueSlickCarousel>

      <!-- Modal Xem Chi Tiết -->
      <b-modal
        v-model="showFullContentModal"
        :title="tinTucSelected?.nameAuthor || 'Chi tiết bài viết'"
        size="xl"
        id="view-full-content"
        centered
        hide-footer
        modal-class="flower-modal-decorated"
        title-class="flower-title-decorated"
        @hidden="resetModalState"
        no-scroll
      >
        <div
          v-if="tinTucSelected"
          class="full-hoa-content col-lg-8 mx-auto p-2"
        >
          <div class="d-flex align-items-center mb-3">
            <p class="modal-name-author small mb-0 text-muted">
              <i class="fas fa-user-edit me-1"></i> Đăng bởi:
              <strong>{{ tinTucSelected.nameAuthor }}</strong>
              <span class="mx-2">|</span>
              <i class="fas fa-calendar-alt me-1"></i>
              {{ formatDate(tinTucSelected.createdAtShow) }}
            </p>
          </div>
          <hr />
          <div class="content-body mt-2">
            <p class="content-text-full">
              {{ displayDescribe }}
            </p>

            <button
              v-if="isLongContent"
              class="text-more-btn btn btn-link p-0 text-primary fw-bold"
              @click="isContentExpanded = !isContentExpanded"
            >
              {{ isContentExpanded ? " Thu gọn" : "Xem thêm" }}
            </button>
          </div>

          <div class="modal-image-area mt-4">
            <div
              class="aspect-ratio-3-2-modal clickable-image-wrapper"
              @click="openImageLightbox(tinTucSelected)"
            >
              <img
                :src="url + tinTucSelected.fileImage.fileId"
                alt="Ảnh chi tiết"
                class="full-modal-image"
              />
            </div>
          </div>
        </div>

        <div
          class="d-flex justify-content-center pt-3 mt-4 border-top flower-footer-actions"
        >
          <ButtonCore
            text="Tin trước"
            variantClass="btn-outline-info-core"
            iconClass="fas fa-chevron-left"
            :handleClick="previousPost"
            :isDisable="isPreviousDisabled"
            class="me-2"
            :customStyle="{ width: '110px' }"
          />
          <ButtonCore
            text="Đóng"
            variantClass="btn-close-core"
            :handleClick="closeModal"
            class="me-2"
            :customStyle="{ width: '90px' }"
          />
          <ButtonCore
            text="Tin sau"
            variantClass="btn-outline-info-core"
            iconClass="fas fa-chevron-right"
            :handleClick="nextPost"
            :isIconAfterText="true"
            :isDisable="isNextDisabled"
            :customStyle="{ width: '110px' }"
          />
        </div>
      </b-modal>

      <!-- Lightbox phóng to ảnh -->
      <vue-easy-lightbox
        :visible="imageLightboxVisible"
        :imgs="imagesShow"
        :index="imageIndex"
        @hide="hideImageLightbox"
      />
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import VueEasyLightbox from "vue-easy-lightbox";
import { ButtonCore } from "@/components/widgets";
import { formatDate, getFomartDateBefore } from "@/utils/time/dateUtils.js";
const MAX_CHAR_LENGTH = 150; // Giới hạn ký tự cho nội dung dài

export default {
  name: "PostItemCarousel",
  components: {
    VueSlickCarousel,
    VueEasyLightbox,
    ButtonCore,
  },
  props: {
    posts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      url: `${process.env.VUE_APP_API_URL}filesminio/view/`,
      formatDate,
      getFomartDateBefore,
      showFullContentModal: false,
      tinTucSelected: null,
      isContentExpanded: false,
      imageLightboxVisible: false,
      imagesShow: [],
      imageIndex: 0,

      // CẤU HÌNH SLICK CAROUSEL (6 item = 3 cột x 2 hàng)
      settings: {
        rows: 3, // Hiển thị 3 hàng
        slidesPerRow: 3, // 3 cột trên mỗi hàng (Tổng cộng 9 item hiển thị cùng lúc)
        slidesToShow: 1, // Chỉ hiển thị 1 slide lớn (chứa grid 3x3)
        slidesToScroll: 1, // Cuộn từng slide lớn

        dots: true,
        arrows: false,
        infinite: false, // Không lặp vô hạn để tránh lỗi logic grid
        speed: 500,
        autoplay: false,

        // RESPONSIVE
        responsive: [
          {
            breakpoint: 1200, // Desktop lớn
            settings: {
              rows: 3,
              slidesPerRow: 3, // 3x3
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 1024, // Laptop/Tablet ngang
            settings: {
              rows: 3,
              slidesPerRow: 2, // 3x2 = 6 item
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 768, // Tablet dọc
            settings: {
              rows: 2,
              slidesPerRow: 2, // 2x2
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 600, // Mobile lớn
            settings: {
              rows: 2,
              slidesPerRow: 1, // 1x2 = 2 item (xếp dọc)
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 480, // Mobile nhỏ
            settings: {
              rows: 2,
              slidesPerRow: 1, // 1x2
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
  computed: {
    currentPostIndex() {
      if (!this.tinTucSelected) return -1;
      return this.posts.findIndex(
        (item) => item._id === this.tinTucSelected._id
      );
    },
    isPreviousDisabled() {
      return this.currentPostIndex <= 0;
    },
    isNextDisabled() {
      return (
        this.currentPostIndex === this.posts.length - 1 ||
        this.currentPostIndex === -1
      );
    },
    isLongContent() {
      return (
        this.tinTucSelected?.describe &&
        this.tinTucSelected.describe.length > MAX_CHAR_LENGTH
      );
    },
    displayDescribe() {
      const describe = this.tinTucSelected?.describe || "";

      if (!this.isLongContent || this.isContentExpanded) {
        return describe;
      }

      return describe.substring(0, MAX_CHAR_LENGTH) + "...";
    },
  },
  filters: {
    truncate(value, length) {
      if (!value) return "";
      return value.length > length ? value.substring(0, length) + "..." : value;
    },
  },
  methods: {
    openPostModal(post) {
      this.isContentExpanded = false;
      this.tinTucSelected = post;
      this.showFullContentModal = true;
    },
    closeModal() {
      this.showFullContentModal = false;
    },
    resetModalState() {
      this.tinTucSelected = null;
      this.isContentExpanded = false;
    },
    previousPost() {
      if (!this.isPreviousDisabled) {
        this.tinTucSelected = this.posts[this.currentPostIndex - 1];
        this.isContentExpanded = false;
      }
    },
    nextPost() {
      if (!this.isNextDisabled) {
        this.tinTucSelected = this.posts[this.currentPostIndex + 1];
        this.isContentExpanded = false;
      }
    },
    openImageLightbox(post) {
      this.imagesShow = [this.url + post.fileImage.fileId];
      this.imageIndex = 0;
      this.imageLightboxVisible = true;
    },
    hideImageLightbox() {
      this.imageLightboxVisible = false;
    },
    next() {
      if (this.$refs.carousel) {
        this.$refs.carousel.next();
      }
    },
    // ✨ HÀM CUỘN PREV ✨
    prev() {
      if (this.$refs.carousel) {
        this.$refs.carousel.prev();
      }
    },
  },
};
</script>

<style scoped>
::v-deep .flower-modal-decorated .modal-content {
  border-radius: 20px;
  border: 3px solid var(--color-primary, --color-primary-dark); /* Viền màu xanh lá */
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  background: linear-gradient(110deg, #f7fcf7, #fbf2f2); /* Nền gradient nhẹ */
}
/* Custom Title Class */
::v-deep .flower-title-decorated {
  font-size: 1.4rem;
  font-weight: 800;
  color: var(--color-primary-dark, #082957);
  /* Thay đổi nền header để nổi bật hơn */
  background: transparent !important;
  border-bottom: 2px solid var(--color-primary);
  padding: 1rem 1.5rem;
}

/* ======================== CONTAINER ======================== */
.hoa-carousel-container {
  width: 100%;
  margin: 0;
  padding: 0;
}

/* FIX: Loại bỏ padding mặc định của Slick để sát lề */
.hoa-carousel-container ::v-deep .slick-list {
  margin: 0 -10px; /* Bù trừ cho padding của item bên trong */
}

.slide-item-wrapper {
  height: 100%;
  padding: 0 8px; /* Giảm gap một chút để giãn card ra thêm */
}

::v-deep .slick-track,
::v-deep .slick-slide > div {
  height: 100%;
  padding: 0 !important;
}
/* ======================== ITEM WRAPPER ======================== */
.item-wrapper {
  padding: 10px; /* Tạo khoảng cách (gap) giữa các thẻ */
  box-sizing: border-box;
}

.hoa-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); */
  transition: transform 0.5s ease;
  border: 1px solid #eee;
  /* min-height không cần thiết nếu nội dung đã có height cố định */
}

.hoa-card:hover {
  /* transform: translateY(-5px); */

  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
}

/* ======================== ẢNH 3:2 ======================== */
.hoa-image-container {
  position: relative;
  width: 100%;
  padding-bottom: 66.66%; /* Tỷ lệ 3:2 */
  overflow: hidden;
  background: #f5f5f5;
}

.hoa-image-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.hoa-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;

  transition: transform 0.4s ease;
}

/* Overlay */
.hoa-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 14px;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.8) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  color: #fff;
}

.hoa-name {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  color: var(--color-white) !important;
  text-overflow: ellipsis;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.hoa-engname {
  margin: 0;
  font-size: 0.95rem;
  opacity: 0.85;
}

/* ======================== CARD BODY ======================== */
.hoa-card-body {
  padding: 18px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

/* SỬA: Cấu hình hiển thị nội dung mô tả */
.hoa-desc {
  font-size: 1.15rem;
  line-height: 1.5; /* Khoảng cách dòng */
  color: #555;
  margin-bottom: 12px;

  /* Cố định 3 dòng cho Desktop */
  height: 4.5em; /* 3 dòng * 1.5em = 4.5em */

  /* Cắt dòng bằng CSS */
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: justify;
  white-space: normal; /* Đảm bảo text wrap */
}

.hoa-card-footer {
  margin-top: auto;
  display: flex;
  justify-content: flex-start;
}

/* ======================== MODAL STYLES ======================== */
.aspect-ratio-3-2-modal {
  width: 100%;
  padding-bottom: 66.66%;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background: #000;
  cursor: pointer;
}

.full-modal-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.content-text-full {
  font-size: 1rem;
  line-height: 1.7;
  color: #333;
  white-space: pre-line;
}

/* Tùy chỉnh Dots của Slick */
::v-deep .slick-dots {
  bottom: -25px;
}
::v-deep .slick-dots li button:before {
  color: var(--color-primary, #2b569a);
  font-size: 10px;
}

/* Responsive tinh chỉnh */
@media (max-width: 576px) {
  .hoa-name {
    font-size: 0.95rem;
  }

  /* SỬA: Cấu hình hiển thị 2 dòng cho Mobile */
  .hoa-desc {
    font-size: 0.95rem; /* Chữ nhỏ hơn một chút */
    line-height: 1.38; /* Giảm line-height */
    height: 2.65em; /* 2 dòng * 1.4em = 2.8em */
    -webkit-line-clamp: 2;
  }

  .item-wrapper {
    padding: 6px;
  }

  ::v-deep .slick-dots {
    bottom: -20px;
  }
}
</style>
